import React from 'react'
import Firebase from 'firebase'
import moment from 'moment'

// react-router
import { useLocation } from 'react-router-dom'

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  ListGroupItem,
  ListGroup,
  Container,
  Row,
  Col,
} from "reactstrap";
// react plugin for creating notifications over the dashboard
import NotificationAlert from "react-notification-alert";

import AuthHeader from "components/Headers/AuthHeader.js";
import Loading from 'components/Misc/Loading';

function Feedback() {
  const location = useLocation();

  const [loadingActive, setLoadingActive] = React.useState(false);
  const [overallSatisfaction, setOverallSatisfaction] = React.useState();
  const [addMoreFeedback, setAddMoreFeedback] = React.useState(false);
  const [listState, setListState] = React.useState({
    toiletsDirty: false,
    paperTowelsEmpty: false,
    toiletPaperEmpty: false,
    soapDispenserEmpty: false,
    floorsDirty: false,
    sinksDirty: false,
  })
  const [feedbackPosted, setFeedbackPosted] = React.useState(false);

  const notificationAlertRef = React.useRef(null);

  const locationRef = React.useRef({
    franchise: decodeURI(location.search.split('=')[1]).split('|')[0],
    address: decodeURI(location.search.split('=')[1]).split('|')[1],
  })

  const notify = (type, title, message, icon) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {" "}
            {title}
          </span>
          <span data-notify="message">{message}</span>
        </div>
      ),
      type: type,
      icon,
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const getCookie = (cname) => {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const postFeedback = async () => {
    try {
      await Firebase.firestore().collection('postedFeedback').add({
        franchise: locationRef.current.franchise,
        location: locationRef.current.address,
        satisfaction: overallSatisfaction,
        additionalFeedback: listState,
      })
      notify(
        "success",
        "Your feedback was submitted successfully.",
        'Thank you for your feedback! It will help us improve our services.',
        "fas fa-check"
      );
      setFeedbackPosted(true);
      let day = new Date();
      day.setTime(day.getTime() + moment().add(1, 'days').set({hour: 4}).diff(moment()));
      const expires = "expires=" + day.toUTCString();
      document.cookie = `enviro-masterFeedback-${location.search.split('=')[1]}=true;` + expires;
    } catch(error) {
      notify(
        "danger",
        "Uh Oh!",
        error.message,
        "fas fa-exclamation-triangle"
      );
    }
  }

  if (feedbackPosted || getCookie(`enviro-masterFeedback-${location.search.split('=')[1]}`) === 'true') {
    return (
      <>
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <AuthHeader
        title={"Thank you for today's feedback!"}
        lead="Please make sure to share your feedback anytime you see Enviro-Master's QR code!"
      />
    </>
    )
  }

  return (
    <>
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <Loading active={loadingActive} />
      <AuthHeader
        title={`Please share you experience at ${locationRef.current.franchise} in ${locationRef.current.address} with us!`}
        lead="What is your overall satisfaction?"
      />
      <Container className="mt--8 pb-5">
        <Row className="justify-content-center">
          <Col lg="5" md="7">
            <Card className="bg-secondary border-0 mb-0">
              <CardHeader className="bg-transparent pb-5">
                <div className="btn-wrapper text-center">
                  <Button
                    className="btn-neutral btn-icon"
                    style={{paddingRight: '1rem', paddingLeft: '1rem', border: overallSatisfaction === 'high' ? '1px #5e72e4 solid' : ''}}
                    onClick={() => setOverallSatisfaction('high')}
                  >
                    <span className="btn-inner--icon mr-1 text-success" style={{fontSize: '3rem'}}>
                      <i className="far fa-grin-hearts"></i>
                    </span>
                  </Button>
                  <Button
                    className="btn-neutral btn-icon"
                    style={{paddingRight: '1rem', paddingLeft: '1rem', border: overallSatisfaction === 'medium' ? '1px #5e72e4 solid' : ''}}
                    onClick={() => setOverallSatisfaction('medium')}
                  >
                    <span className="btn-inner--icon mr-1 text-yellow" style={{fontSize: '3rem'}}>
                      <i className="far fa-meh"></i>
                    </span>
                  </Button>
                  <Button
                    className="btn-neutral btn-icon"
                    style={{paddingRight: '1rem', paddingLeft: '1rem', border: overallSatisfaction === 'low' ? '1px #5e72e4 solid' : ''}}
                    onClick={() => setOverallSatisfaction('low')}
                  >
                    <span className="btn-inner--icon mr-1 text-danger" style={{fontSize: '3rem'}}>
                      <i className="far fa-frown"></i>
                    </span>
                  </Button>
                </div>
              </CardHeader>
              <CardBody className="px-lg-5 py-lg-5">
                {
                  overallSatisfaction && overallSatisfaction !== 'high' ?
                  <>
                    <Col className="mb-3 d-flex flex-row align-items center">
                      <span className="ml-3">
                        <label className="custom-toggle text-primary">
                          <input
                            type="checkbox"
                            className="text-primary"
                            defaultChecked={addMoreFeedback}
                            id="requiresCodeRead"
                            onChange={e => {
                              setAddMoreFeedback(e.target.checked);
                            }}
                          />
                          <span
                            className="custom-toggle-slider rounded-circle text-primary"
                          />
                        </label>
                      </span>
                      <span className="text-muted pb-2 ml-3">
                        Add more feedback
                      </span>
                    </Col>
                  </>
                  : null
                }
                {
                  addMoreFeedback ?
                  <>
                    <ListGroup className="mb-3">
                      <ListGroupItem className={listState.toiletsDirty ? "active" : ''} onClick={() => setListState(prevState => ({ ...prevState, toiletsDirty: !prevState.toiletsDirty }))}>Toilets dirty</ListGroupItem>
                      <ListGroupItem className={listState.paperTowelsEmpty ? "active" : ''} onClick={() => setListState(prevState => ({ ...prevState, paperTowelsEmpty: !prevState.paperTowelsEmpty }))}>Paper towels dispenser empty</ListGroupItem>
                      <ListGroupItem className={listState.toiletPaperEmpty ? "active" : ''} onClick={() => setListState(prevState => ({ ...prevState, toiletPaperEmpty: !prevState.toiletPaperEmpty }))}>Toilet paper dispenser empty</ListGroupItem>
                      <ListGroupItem className={listState.soapDispenserEmpty ? "active" : ''} onClick={() => setListState(prevState => ({ ...prevState, soapDispenserEmpty: !prevState.soapDispenserEmpty }))}>Soap dispenser empty</ListGroupItem>
                      <ListGroupItem className={listState.floorsDirty ? "active" : ''} onClick={() => setListState(prevState => ({ ...prevState, floorsDirty: !prevState.floorsDirty }))}>Floors dirty</ListGroupItem>
                      <ListGroupItem className={listState.sinksDirty ? "active" : ''} onClick={() => setListState(prevState => ({ ...prevState, sinksDirty: !prevState.sinksDirty }))}>Sinks dirty</ListGroupItem>
                    </ListGroup>
                  </>
                  : null
                }
                <Button
                  color="primary"
                  disabled={!overallSatisfaction}
                  onClick={postFeedback}
                >
                  Submit
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Feedback